import { MapUiTheme } from '../../common';
import { padding } from '../../common/theme/utils';

export const inputTheme = {
  defaultStyles: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    lineHeight: (theme: MapUiTheme) => theme.lineHeight.snug,
    border: (theme: MapUiTheme) => `1px solid ${theme.colors.neutral500}`,
    borderRadius: 8,

    '::placeholder': {
      color: (theme: MapUiTheme) => `1px solid ${theme.colors.text200}`,
    },
    '&:focus': {
      outline: 0,
    },
    '&:disabled': {
      borderColor: (theme: MapUiTheme) => theme.colors.neutral400,
    },
  },
  isCompleted: {
    '::placeholder': {
      color: (theme: MapUiTheme) => `1px solid ${theme.colors.text200}`,
    },
    borderColor: (theme: MapUiTheme) => theme.colors.neutral500,
    backgroundColor: (theme: MapUiTheme) => theme.colors.interaction100,
  },
  isVerified: {
    '::placeholder': {
      color: (theme: MapUiTheme) => `1px solid ${theme.colors.text200}`,
    },
    borderColor: (theme: MapUiTheme) => theme.colors.success300,
  },
  isInvalid: {
    '::placeholder': {
      color: (theme: MapUiTheme) => `1px solid ${theme.colors.text200}`,
    },
    color: (theme: MapUiTheme) => theme.colors.danger300,
    backgroundColor: (theme: MapUiTheme) => theme.colors.neutral100,
    fontWeight: 'bold',
    borderColor: (theme: MapUiTheme) => theme.colors.danger300,
  },
  xs: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
  },
  sm: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  md: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['3'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  lg: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['4'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  xl: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['5'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
};
